import { ListingCard } from "./ListingCard";

export const WRAP = "max-w-[1360px] mx-auto px-6 lg:px-10";
export const GRID = "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5 lg:gap-6";

export function MarketSection({ id, index, eyebrow, title, accent, intro, items, catName, tone = "", action }) {
  if (!items?.length) return null;
  return (
    <section id={id} data-testid={`mkt-section-${id}`} className={`scroll-mt-24 ${tone}`}>
      <div className={`${WRAP} py-20 lg:py-24`}>
        <header className="flex flex-wrap items-end justify-between gap-6 mb-10 lg:mb-12">
          <div className="max-w-2xl">
            <div className="label-eyebrow mb-3">{index} · {eyebrow}</div>
            <h2 className="font-serif-display text-3xl sm:text-4xl lg:text-5xl text-white leading-[1.05]">
              {title} {accent && <span className="italic text-[#D4AF37]">{accent}</span>}
            </h2>
            {intro && <p className="text-neutral-400 mt-4 text-base leading-relaxed">{intro}</p>}
          </div>
          {action}
        </header>
        <div className={GRID}>
          {items.map((l, i) => <ListingCard key={l.id} listing={l} categoryName={catName(l.category)} index={i} />)}
        </div>
      </div>
    </section>
  );
}
